import { Store } from "../utils/Store";

import { SessionStore } from "../uidispatcherapi/SessionStore";
import PositionRulesService from "../services/PositionRulesService";
import { PositionRules } from "../services/PositionRulesService";

import * as TrackingUtil from "../utils/TrackingUtil";

let positionRules: PositionRules;

class PositionRulesStoreImpl extends Store {
    constructor() {
        super();
        this.loadPositionRules();
    }

    async loadPositionRules() {
        const country: string = SessionStore.getCountry();
        try {
            // TODO (VH): what if this fails ... should we retry?
            const rules = await PositionRulesService.getPositionRules(country);
            positionRules = rules;
        } catch (error) {
            TrackingUtil.trackUIError("PositionRulesStore", "getPositionRules failed", error);
        } finally {
            this.trigger();
        }
    }

    getState(): PositionRules {
        return positionRules;
    }
}

export default new PositionRulesStoreImpl();
